import React from "react";
import { Button } from "@material-ui/core";
import './styles.scss';
import stringJp from '../../../constants/stringJP';

const AddProduct = ({handleClickAddPrd}) => {

    return (
        <div  
            className="btnAddProduct" 
            style={{ margin: "2px 17px 10px 17px", textAlign: "right", marginTop:-5 }}>
            
                <Button
                    variant="contained"
                    component="span"
                    className="add"
                    onClick={() => handleClickAddPrd()}
                >
                    <div className="btn-add">{stringJp.label_add_product}</div>
                </Button>
           
        </div>
    );
}
export default AddProduct;
